import axios from "@/axios";
import * as types from '@/store/mutation-types'

export default {
    namespaced: true,
    state: {
        tasksType: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/SettingsHr/TaskTypes').then(({ data }) => {
                commit(types.STORE_TASKS_TYPES, data)
                return data
            })
        },

        create({ commit }, { name, percentage }) {
            return axios.post('/SettingsHr/TaskType', { name, percentage}).then((data) => {
                return data
            })
        },

        update({ commit }, { id, name, percentage }) {
            return axios.put(`/SettingsHr/TaskType/${id}`, { 
                name,
                percentage
            }).then((data) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`/SettingsHr/TaskType/${id}`).then((data) => {
                return data
            })
        }
    },

    mutations: {
        [types.STORE_TASKS_TYPES](state, tasksType) {
            state.tasksType = tasksType
        }
    },

    getters: {
        getById: state => id => state.tasksType.find(c => c.id === id) 
    }
}